import React from 'react'
import { chatStatusColor } from '@ztechapps/chat.common'
import { StatusColorBadge, StatusColorDot, findStatus } from '@ztechapps/webui.util'

export type ChatStatusProps = { status: string }
export type ChatStatusBadgeProps = ChatStatusProps & { className?: string }

export const ChatStatusBadge = ({ status, className }: ChatStatusBadgeProps) => (
  <StatusColorBadge status={status} color={findStatus(chatStatusColor, status)} className={className} />
)

export const ChatStatus = ({ status }: ChatStatusProps) => (
  <StatusColorDot value={status} color={findStatus(chatStatusColor, status)} />
)
